import { render } from "./BadgeComponent.vue?vue&type=template&id=7154d6e1&ts=true"
import script from "./BadgeComponent.vue?vue&type=script&lang=ts"
export * from "./BadgeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__